import { defineMaterial, type MaterialComponentProps } from '@h5/schema';
import { VideoPropsSchema, type VideoProps } from './schema';

export { VideoPropsSchema, type VideoProps };

/** 视频物料：编辑态只显示封面/占位，不加载视频；预览态渲染 <video>。 */
function VideoView({ props, ctx }: MaterialComponentProps<VideoProps>) {
  const box: React.CSSProperties = { width: '100%', height: '100%', background: '#000', overflow: 'hidden', boxSizing: 'border-box' };

  if (ctx.mode === 'edit' || !props.src) {
    const width = Math.ceil(ctx.layer.rect.w * ctx.scale * 2);
    return (
      <div style={{ ...box, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {props.poster ? (
          <img src={ctx.assets.url(props.poster, { width })} alt="" draggable={false} style={{ width: '100%', height: '100%', objectFit: 'cover', pointerEvents: 'none' }} />
        ) : (
          <span style={{ color: '#999', fontSize: 12 }}>{props.src ? '视频' : '请选择视频'}</span>
        )}
        <span style={{ position: 'absolute', width: 44, height: 44, borderRadius: '50%', background: 'rgba(0,0,0,.5)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>▶</span>
      </div>
    );
  }

  return (
    <video
      src={ctx.assets.url(props.src)}
      poster={props.poster ? ctx.assets.url(props.poster) : undefined}
      autoPlay={props.autoplay}
      loop={props.loop}
      muted={props.muted}
      controls={props.controls}
      playsInline
      // 微信 x5 内核私有属性，走展开绕开 JSX 类型
      {...({ 'webkit-playsinline': 'true', 'x5-playsinline': 'true' } as Record<string, string>)}
      style={{ ...box, objectFit: 'contain' }}
    />
  );
}

export const videoMaterial = defineMaterial<VideoProps>({
  id: 'video',
  version: 1,
  name: '视频',
  category: 'media',
  icon: '▶',
  defaultSize: { w: 335, h: 188 },
  defaultProps: VideoPropsSchema.parse({}),
  propsSchema: VideoPropsSchema,
  component: VideoView,
});
